module.exports = {
  title: 'Blurred List with Reanimated and Expo Blur',
  author: 'Enzo Manuel Mangano',
  date: '2024-10-01',
  slug: 'motion-blur',
  tags: ['reanimated', 'expo-blur'],
};
